import React from "react";
import BusDetailsCard from "./BusDetailsCard";

export default function Bus15() {
  return (
    <BusDetailsCard
      busId="bus15"
      title="Bus 15 - Route Details"
      busName="Bus 15"
      vehicleNo="TN74O5234"
      backTo="/?buses=1"
    />
  );
}